import { render, staticRenderFns } from "./Microcart.vue?vue&type=template&id=045d3ee4&scoped=true&"
import script from "./Microcart.vue?vue&type=script&lang=js&"
export * from "./Microcart.vue?vue&type=script&lang=js&"
import style0 from "./Microcart.vue?vue&type=style&index=0&id=045d3ee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045d3ee4",
  null
  
)

export default component.exports